import { Sku } from './sku'

export class StoreItem extends Sku {

  sku_id: number
  brand: string
  category: string
  description: string
  aliyun_img_url: string
  attributes: any

  price: number
  count: number
  sku_multiple: number
  time_multiple: number

  constructor(x: any) {
    super(x)
    this.price = x.price || 0
    this.count = x.count || 0
    this.sku_multiple = x.sku_multiple || 1
    this.time_multiple = x.time_multiple || 1
  }

  get _cost(): number {
    return this.price / this.sku_multiple / this.time_multiple
  }

  get _basePrice(): number {
    return this.price / this.sku_multiple
  }

  get _increaseFromBasePrice(): number {
    return this.price - this._basePrice
  }

}



// WEBPACK FOOTER //
// ./src/app/models/item/store-item.ts